// The off-label warning of an article (docs/off-label-warnings.md): the two
// kinds of warning, and the countries a warning can state today. The api, the
// admin and the webapp read this one list, so a country added here fails the
// type check of every consumer that words it (the webapp's country phrase, the
// admin's label) until it is handled.

import type { ArticleOffLabelKind } from "../../service/prisma/client.ts";

// The kind is the Prisma enum, so a value added to the column is a type error in
// every consumer that words it. The list below is its runtime copy for the
// frontends, which cannot import Prisma's runtime enums.
export type OffLabelKind = ArticleOffLabelKind;

export const OFF_LABEL_KINDS = [
  "off_label",
  "not_authorised",
] as const satisfies readonly OffLabelKind[];

/**
 * The countries a warning can state. The column holds any ISO 3166-1 alpha-2
 * code; the routes and the readers accept only these, because each one needs a
 * country phrase in every language ("in France").
 */
export const OFF_LABEL_COUNTRIES = ["FR"] as const;

export type OffLabelCountry = (typeof OFF_LABEL_COUNTRIES)[number];

/** A stored code narrowed to a country the readers can word. */
export function offLabelCountry(code: string): OffLabelCountry {
  const country = OFF_LABEL_COUNTRIES.find((candidate) => candidate === code);
  if (country === undefined)
    throw new Error(
      `Invariant: no off-label country phrase for the stored country ${code}`,
    );
  return country;
}
